import useQueryMemo from '@/common/hooks/urlMemo';
import { useContext, useMemo } from 'react';
import OnePageStripeSubscriptionV3 from './components/v3/OnePageStripeSubscriptionV3';
import { LanguageContext } from '@/common/contexts/LanguageContext';
import OnePageStripeSubscribtionPayment from './components/v1/OnePageStripeSubscribtionPayment';
import OnePageStripeSubscriptionV4 from './components/v4/OnePageStripeSubscriptionV4';

export const PAYU_CHECKOUT_VERSION_NAME = 'payu_checkout_version';

const PAYU_CHECKOUT_VERSIONS = {
	CA: 'checkout_a',
	CB: 'checkout_b',
	CC: 'checkout_c',
	CD: 'checkout_d',
};

const SubscriptionStripeWrapper = () => {
	const queryMemo = useQueryMemo();
	const { lang } = useContext(LanguageContext);

	const checkout = useMemo(() => {
		let version = queryMemo.get(PAYU_CHECKOUT_VERSION_NAME);

		if (!version) {
			version = window.localStorage.getItem(PAYU_CHECKOUT_VERSION_NAME);
		}

		if (version) {
			window.localStorage.setItem(PAYU_CHECKOUT_VERSION_NAME, version || '');
		}

		const usingTest = !!version;

		// if (PAYU_CHECKOUT_VERSIONS.CB === version) {
		// 	return <OnePagePayuPaymentV2 />;
		// }

		if (PAYU_CHECKOUT_VERSIONS.CC === version) {
			return <OnePageStripeSubscriptionV3 />;
		}

		if (PAYU_CHECKOUT_VERSIONS.CD === version) {
			return <OnePageStripeSubscriptionV4 />;
		}

		return <OnePageStripeSubscribtionPayment usingTest={usingTest} />;
	}, []);

	return <>{checkout}</>;
};

export default SubscriptionStripeWrapper;
